var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckEmpty = function SvgCheckEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 28,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1A6.51 6.51 0 0 0 1 7.5 6.51 6.51 0 0 0 7.5 14 6.51 6.51 0 0 0 14 7.5 6.51 6.51 0 0 0 7.5 1Zm0 1C10.543 2 13 4.457 13 7.5S10.543 13 7.5 13A5.493 5.493 0 0 1 2 7.5C2 4.457 4.457 2 7.5 2Z"
  })));
};

export default SvgCheckEmpty;